
    import { Options, Vue } from "vue-class-component";
    import { Prop } from "vue-property-decorator";

    @Options({
        name: "VisualizarSql",
    })
    export default class VisualizarSql extends Vue {
        @Prop() readonly modal!: string;
        @Prop() readonly descricao!: string;

        get descricaoExibicao(): string {
            return this.descricao && this.descricao.trim() !== "" ? this.descricao : "Sem descricao informada.";
        }
    }
